import { render, staticRenderFns } from "./TransactionStorePagination.vue?vue&type=template&id=0f10582b&scoped=true"
import script from "./TransactionStorePagination.vue?vue&type=script&lang=js"
export * from "./TransactionStorePagination.vue?vue&type=script&lang=js"
import style0 from "./TransactionStorePagination.vue?vue&type=style&index=0&id=0f10582b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10582b",
  null
  
)

export default component.exports